export interface DiscountCalculationRow {
  so_luong?: number;
  ma_vt_data?: BanHangRecord;
  tl_ck?: number;
  ck_nt?: number;
  ma_thue_data?: {
    thue_suat?: number;
  };
  [key: string]: BanHangValue;
}

export const roundToOneDecimal = (value: number) => Math.round((Number(value) || 0) * 10) / 10;

const calculateDiscountAmount = (baseAmount: number, discountRate: number) =>
  roundToOneDecimal(((Number(baseAmount) || 0) * (Number(discountRate) || 0)) / 100);

const calculateTaxAmount = (amountAfterDiscount: number, taxRate: number) =>
  roundToOneDecimal(((Number(amountAfterDiscount) || 0) * (Number(taxRate) || 0)) / 100);

export const toNumber = (value: BanHangValue) => Number(value) || 0;

const getLoaiCkString = (loai_ck?: string | number) =>
  typeof loai_ck === 'number' ? String(loai_ck) : (loai_ck ?? '');

export const calculateRowValues = (
  row: DiscountCalculationRow,
  loai_ck?: string | number,
  ck_tl_nt?: number,
  changedField?: string
): Partial<DiscountCalculationRow> => {
  const so_luong = toNumber(row.so_luong);
  const gia_nt2 = toNumber(row.gia_nt2);
  const gia_nt = toNumber(row.gia_nt ?? row.ma_vt_data?.gia_ton);
  const tien_nt2 = row.tien_nt2 !== undefined ? toNumber(row.tien_nt2) : roundToOneDecimal(so_luong * gia_nt2);
  const tien_tck_nt =
    row.tien_tck_nt !== undefined ? toNumber(row.tien_tck_nt) : roundToOneDecimal(so_luong * gia_nt2 || tien_nt2);
  const tien_nt = roundToOneDecimal(so_luong * gia_nt);

  let tl_ck_val = toNumber(row.tl_ck);
  let ck_nt_val = toNumber(row.ck_nt);

  const loaiCkStr = getLoaiCkString(loai_ck);

  if (loaiCkStr === '2') {
    tl_ck_val = Number(ck_tl_nt) || 0;
    ck_nt_val = calculateDiscountAmount(tien_tck_nt, tl_ck_val);
  } else if (loaiCkStr === '3') {
    // ck_tl_nt is the invoice-level discount pool. The backend has already
    // allocated it to eligible product rows and returned each value as ck_nt.
    // Keeping the row value also leaves shipping-fee rows (PGH) at zero.
    ck_nt_val = toNumber(row.ck_nt);
    tl_ck_val = 0;
  } else if (loaiCkStr === '1') {
    const tlCkNumber = toNumber(row.tl_ck);
    const hasPositiveTlCk = tlCkNumber > 0;

    if (changedField === 'tl_ck') {
      tl_ck_val = tlCkNumber;
      if (hasPositiveTlCk) {
        ck_nt_val = calculateDiscountAmount(tien_tck_nt, tl_ck_val);
      }
    } else if (changedField === 'ck_nt') {
      ck_nt_val = toNumber(row.ck_nt);
    } else if (['tien_nt2', 'gia_nt2', 'so_luong', 'tien_tck_nt'].includes(changedField || '')) {
      if (hasPositiveTlCk) {
        tl_ck_val = tlCkNumber;
        ck_nt_val = calculateDiscountAmount(tien_tck_nt, tl_ck_val);
      } else {
        ck_nt_val = toNumber(row.ck_nt);
      }
    }
  }

  const amountAfterDiscount = roundToOneDecimal(tien_tck_nt - ck_nt_val);
  const taxRate = toNumber(row.ma_thue_data?.thue_suat);
  const thue_nt = calculateTaxAmount(amountAfterDiscount, taxRate);

  return {
    tien_nt,
    tien_nt2,
    tien_tck_nt,
    tl_ck: tl_ck_val,
    ck_nt: ck_nt_val,
    thue_nt
  };
};
